export default __webpack_public_path__ + "static/media/1.7615ec4c.png";